import React from 'react';
import useWebsites from 'modules/website/hooks/useWebsites';
import { LoadingOutlined } from '@ant-design/icons';
import Ninja from '@ninja';
import { Select, Typography, Button } from 'antd';
import Icon from '@mdi/react';
import { mdiCheckCircle, mdiAlertCircle } from '@mdi/js';
import P from 'router/paths';
import { Link } from 'react-router-dom';

const WebsitesSelect = (props) => {
  const { websites, isLoading } = useWebsites();

  const loading = () => (
    <LoadingOutlined className='flex items-center justify-center m-auto text-3xl h-9' spin />
  );

  return (
    <Select
      style={{ minWidth: 100 }}
      placeholder='Choose Website'
      maxTagCount='responsive'
      allowClear
      popupMatchSelectWidth={false}
      notFoundContent={isLoading && websites.length === 0 ? loading() : undefined}
      {...props}
    >
      {websites?.map((website) => {
        const isVerified = website.verified;

        return (
          <Select.Option
            key={website.id}
            value={website.id}
            label={website.name}
            disabled={!isVerified}
          >
            <div className='flex items-center gap-4 justify-between'>
              <div className='flex items-center gap-1'>
                <Icon
                  size={0.6}
                  path={isVerified ? mdiCheckCircle : mdiAlertCircle}
                  color={isVerified ? Ninja.colors.success : Ninja.colors.warning}
                />

                <Typography.Title level={5} className={`${!isVerified ? 'opacity-50' : ''} !m-0`}>
                  {website.domain}
                </Typography.Title>
              </div>
              {!isVerified && (
                <Link className='block' to={P.WEBSITES.EDIT(website.id)}>
                  <Button size='small' type='primary'>
                    Verify Now
                  </Button>
                </Link>
              )}
            </div>
          </Select.Option>
        );
      })}
    </Select>
  );
};

export default WebsitesSelect;
